import { createContext, useContext } from 'react';

interface TreeChartContextValue {
  collapsedIds: Set<string>;
  toggleCollapse: (id: string) => void;
}

export const TreeChartContext = createContext<TreeChartContextValue>({
  collapsedIds: new Set(),
  toggleCollapse: () => {},
});

export function useTreeCollapse() {
  return useContext(TreeChartContext);
}
